import React from "react";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {GridTable} from "../../../../Components/Grid";
import {LoanQueueRow} from "./LoanQueueRow";

interface LoanQueueTableProps {
    handleLoanQueueItem: (loanId: string, loanStatus: number) => void;
    handlePackingList: (loanId: string) => void;
    handleSetLoanSearchCriteria: (criteria: Record<string, any>) => void;
    handleRemoveFromQueue: (loanId: string) => void;
    loanSearchCriteria: Record<string, any>;
    queue: Record<string, any>[];
}

export const LoanQueueTable = ({
                                   handleLoanQueueItem,
                                   handlePackingList,
                                   handleSetLoanSearchCriteria,
                                   handleRemoveFromQueue,
                                   loanSearchCriteria,
                                   queue,
                               }: LoanQueueTableProps) => {

    loanSearchCriteria?.ApplySorting && loanSearchCriteria.ApplySorting(loanSearchCriteria, queue);

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        let criteria = {...loanSearchCriteria};
        const columnId = (event.target as HTMLElement).dataset.id;
        criteria.UpdateSorting(columnId);
        criteria.loadSearchResults = false;
        handleSetLoanSearchCriteria(criteria);
    };

    const isQueueEmpty = isArrayNullOrEmpty(queue);

    return <>
        <GridTable className="searchResults" parentClass={`margin--topNone`}>
            <thead>
            <tr>
                <th onClick={handleOrderClick} className="is-clickable" data-id="title">Order Date</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="title">Title</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="shelfLocation">Shelf Location</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="accessNumber">Access Number</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="patron">Patron</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="shippingLocation">Shipping
                    Location
                </th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="needFromFormatted">Need From
                </th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="student">Student</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="loanStatusText">Status</th>
                <th scope={"col"} className={"align-center"}>
                    Actions
                </th>
            </tr>
            </thead>
            <tbody>
            {
                !isQueueEmpty && queue &&
                queue.map((queuedItem: Record<string, any>) => {
                    const handleDelete = () => handleRemoveFromQueue(queuedItem.queueItemId);
                    const handleLoan = () => handleLoanQueueItem(queuedItem.queueItemId, queuedItem.loanStatus);
                    const handlePacking = () => handlePackingList(queuedItem.queueItemId);

                    return <LoanQueueRow
                        key={queuedItem.queueItemId}
                        handleDelete={handleDelete}
                        handleLoan={handleLoan}
                        handlePacking={handlePacking}
                        loan={queuedItem}
                    />;
                })
            }
            {
                isQueueEmpty &&
                <tr data-testid={`no-order-row`}>
                    <td colSpan={10} className={`text-center`}>No results found.</td>
                </tr>
            }
            </tbody>
        </GridTable>
    </>;
};

